import { EntityService } from '../../../service/EntityService';

export class TaxService extends EntityService {

  static entity = 'api/app/tax';

  static getAll(): Promise<any> {
    return this.axios.get(`${this.entity}/all`).then(res => res.data);
  }
}
